<template>
  <li>
    <span>
      {{widgetInfo.label}}
      <em v-if="widgetInfo.value || !isNaN(widgetInfo.value)">{{widgetInfo.value}}</em>
      <em v-else>{{ EMPTY_TEXT }}</em>
      {{widgetInfo.subLabel}}
    </span>
  </li>
</template>

<script>
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';

export default {
  name: 'WPerfFooterHInfo',
  props: {
    widgetInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      EMPTY_TEXT,
    };
  },
  watch: {
    widgetInfo: {
      handler(widgetValue) {
        if (widgetValue.rscUnit && widgetValue.rscUnit.toUpperCase() === 'COUNT') {
          widgetValue.rscUnit = '';
        } else if (widgetValue.rscUnit) {
          widgetValue.value = convertValuByUnit(widgetValue.value, widgetValue.rscUnit, true, true, false) || '-';
        }
      },
      immediate: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/PerfFooterHInfo.vue